var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBaseForeground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 202.69 144.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fc9e44f4-be19-43c4-863f-f675134c8323{fill:#815aaf;}.f2dac5b0-4bd5-46cf-aea5-ebf5e5693a31{isolation:isolate;}.a850be29-39ab-42fe-a410-5fec3513bb5b{fill:#fff;}.e8f436f7-95bb-4c33-976f-f2219d490e85{fill:#c4a4e2;}.b9ae7d54-61d4-4384-b65d-e06add128bf6{fill:#8661c5;}.f5d8ad3d-f5ea-4142-81de-653d5df917c1{fill:#9e6eca;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bc6f2e4d-c97b-454e-8343-226548931f14",
    "data-name": "CIRCUIT FINAL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fc9e44f4-be19-43c4-863f-f675134c8323",
    d: "M148,67.8,114.43,87.31c-7.1,4.12-18.65,4.12-25.8,0L54.85,67.8c-3.6-2.07-5.4-4.8-5.39-7.52L49.4,83.4c0,2.72,1.78,5.45,5.38,7.52l33.79,19.51c7.14,4.13,18.7,4.13,25.8,0l33.56-19.51c3.53-2,5.3-4.73,5.3-7.42l.07-23.12C153.29,63.07,151.53,65.75,148,67.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f2dac5b0-4bd5-46cf-aea5-ebf5e5693a31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a850be29-39ab-42fe-a410-5fec3513bb5b",
    d: "M71.21,79.4c4.41,2.55,8,8.74,8,13.82s-3.62,7.14-8,4.59-8-8.75-8-13.84S66.78,76.84,71.21,79.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e8f436f7-95bb-4c33-976f-f2219d490e85",
    d: "M71.2,79.4c4.42,2.55,8,8.75,8,13.83s-3.62,7.13-8,4.58-8-8.75-8-13.84S66.78,76.85,71.2,79.4Zm0,17.33c3.9,2.25,7.09.44,7.1-4a15.58,15.58,0,0,0-7.06-12.21c-3.89-2.24-7.08-.43-7.09,4a15.57,15.57,0,0,0,7.05,12.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b9ae7d54-61d4-4384-b65d-e06add128bf6",
    points: "72.06 92.5 73.78 93.49 73.78 94.97 68.55 91.95 68.55 90.47 70.4 91.54 70.41 87.83 68.56 86.76 68.57 85.28 72.08 87.3 72.06 92.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b9ae7d54-61d4-4384-b65d-e06add128bf6",
    d: "M71.25,86a1.72,1.72,0,0,1-1-1.48v-.38c0-.51.27-.75,1-.33a1.68,1.68,0,0,1,1,1.49v.37C72.25,86.15,72,86.4,71.25,86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f5d8ad3d-f5ea-4142-81de-653d5df917c1",
    d: "M147.91,52.86l-6.55-3.78,0,9.46c0,2.07-1.37,4.14-4.09,5.72l-25.87,15c-5.47,3.18-14.38,3.18-19.89,0l-26-15c-2.78-1.6-4.16-3.7-4.16-5.8l0-9.42-6.57,3.82c-7.1,4.12-7.06,10.82.09,14.94L88.63,87.31c7.15,4.12,18.7,4.12,25.8,0L148,67.8C155.1,63.67,155.06,57,147.91,52.86Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseForeground);
export default __webpack_public_path__ + "static/media/base-foreground.9c949546.svg";
export { ForwardRef as ReactComponent };